<template>
  <div class="columns">
    <div class="column">
      <div class="menu">
        <!-- <router-link to="/"> -->
        <a @click="goLogin">
          <span class="icon">
            <i class="fa fa-user-o"></i>
          </span> Login
        </a>
        <!-- </router-link> -->
      </div>
    </div>
  </div>
</template>
<style scoped>
.menu {
  display: inline-flex;
  margin-right: 24px;
}
</style>
<script>
export default {
  methods: {
    goLogin() {
      location.reload();
      //      let href = location.href;
      //      location.href = href.substring(0, href.indexOf("#"));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/NavBar.vue